import * as React from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn,
  GridDetailRow,
  GridToolbar,
} from "@progress/kendo-react-grid";
import "./RFQ.scss";
import RFQRequestDetails from "./RFQRequestDetails";
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

class RFQDetailsComponent extends GridDetailRow {
  constructor() {
    super();
    this.state = {
      // dataItem :this.props.dataItem
    };
  }

  componentDidMount() {}

  render() {
    const dataItem = this.props.dataItem;
    return (
      <div>
        {/*  */}
        <RFQRequestDetails
          data={this.props.dataItem}
          onAcceptNcreateQuotationClicked={
            this.props.onAcceptNcreateQuotationClicked
          }
        ></RFQRequestDetails>
        {/* <Grid style={{ width: "500px" }} data={dataItem.details}></Grid> */}
      </div>
    );
  }
}

export default RFQDetailsComponent;
